import React, { Fragment, useEffect } from "react";
import CompanyHeader from "../../components/CompanySite/CompanyHeader";
import CompanyHero from "../../components/CompanySite/CompanyHero";
import CompanyAbout from "../../components/CompanySite/CompanyAbout";
import CompanyFeatures from "../../components/CompanySite/CompanyFeatures";
import CompanyDetails from "../../components/CompanySite/CompanyDetails";
import ContactSection from "../../components/ContactSection/ContactSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Entity } from "../../data/companies";

interface Props {
  entity: Entity;
}

// ============================================================
// Company site ka home — KOT design me, company ke content ke saath.
// Nav: Home | KOT Global | Contact (CompanyHeader)
// Sections: Hero → About → Commitments → Contact → Programs
// (Removed on user request: Services accordion, brand strip,
//  ecosystem marquee, companies chips, philosophy slider)
// ============================================================
const CompanyHome: React.FC<Props> = ({ entity }) => {
  useEffect(() => {
    document.title = `${entity.name} — ${entity.tagline}`;
  }, [entity]);

  return (
    <Fragment>
      <div className="ai-agency">
        <div className="body_wrap o-clip">
          <CompanyHeader entity={entity} />
          <main>
            <CompanyHero entity={entity} />
            <div id="about">
              <CompanyAbout entity={entity} />
            </div>
            <CompanyFeatures entity={entity} />
            <CompanyDetails entity={entity} />
            <div id="contact">
              <ContactSection />
            </div>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyHome;
